import React from 'react';
import Login from './Login';

function AuthPage() {
  return <Login />;
}

export default AuthPage;
